// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__h1YNW"};